import React from 'react';
import {styled} from '@mui/material';
import {useAppProps} from '../../App';
import {ArchivePageData, ArchiveYearPageData, ArchiveYearPagePageData, RootPageData} from '../../tools/front-props';
import {Navigation} from '../navigation';
import {WyswigView} from "../wyswig-view";
import {useLocation} from "react-router-dom";


const NominationsContainer = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: space-between;
    padding-top: 20px;
`;

const NominationsList = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const NominationLink = styled('a')`
    text-decoration: none;
    color: #6F6F6E;
    font-weight: bold;
    font-size: 18px;
    text-transform: uppercase;
`;

const PageList: React.FC<{ listItems: { title: string, slug: string }[] }> = ({listItems}) => {
    return <NominationsContainer>
        <NominationsList>
            {listItems.map(listItem => {
                return <NominationLink href={`${listItem.slug}`} key={listItem.title}>
                    {listItem.title}
                </NominationLink>;
            })}
        </NominationsList>
    </NominationsContainer>
}

export const Archive: React.FC = () => {
    const location = useLocation();
    console.log(location.pathname);
    const {pageData} = useAppProps();
    const mainPageData = pageData as RootPageData;

    const split = location.pathname.split('/');

    if (split.length == 2) { // /archive
        const yearsPageData = pageData as ArchivePageData
        return <>
            <h1>Архив</h1>
            <PageList listItems={yearsPageData.map(year => {
                return {title: year.year, slug: `/archive/${year.year}`};
            })}/>
        </>
    }
    if (split.length == 3) { // /archive/:year
        const yearPageData = pageData as ArchiveYearPageData
        if (yearPageData) {
            return <>
                <h1>Архив - {yearPageData.year} год</h1>
                <PageList listItems={yearPageData.pages.map(p => {
                    return {title: p.title, slug: `/archive/${yearPageData.year}/${p.slug}`};
                })}/>
            </>
        }
    }
    if (split.length == 4) { // /archive/:year/:page
        const yearPagePageData = pageData as ArchiveYearPagePageData
        if (yearPagePageData) {
            return <>
                <h1>Архив - {yearPagePageData.year} год - {yearPagePageData.title}</h1>
                <WyswigView
                    dangerouslySetInnerHTML={{__html: yearPagePageData.content}}/>
            </>
        }
    }

    return null;
};